import { Grid, Stack, Typography } from "@mui/material";
import { TradeStyles } from "../trade/styles/Trade.styles";

type TitleProps = {
  title: {
    partA?: string;
    partB: string;
  };
  subtitle?: string;
};
export default function Title({ title, subtitle }: TitleProps) {
  const classes = TradeStyles();

  return (
    <Grid item xs={12}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 0, sm: 1 }}
        id="account-selection-title">
        <Typography className={classes.titleA}>{title.partA}</Typography>
        <Typography className={classes.titleB}>{title.partB}</Typography>
      </Stack>
      {subtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
    </Grid>
  );
}
